import Vue from 'vue'

export const popUpStore = Vue.observable({
  isVisible: false,
})

export const popUpMethods = {
  getVisibility() {
    return popUpStore.isVisible
  },
  setVisibility(visibility) {
    if (typeof visibility === 'boolean') {
      popUpStore.isVisible = visibility
    } else {
      // console.error('Visibility must be a boolean value.')
    }
  },
  showPopUp() {
    this.setVisibility(true)
  },
  hidePopUp() {
    this.setVisibility(false)
  },
  togglePopUp() {
    this.setVisibility(!popUpStore.isVisible)
  },
  updatePopUp(visibility) {
    this.setVisibility(visibility)
  },
}
